import get from 'lodash/get';
import Auth from '@Services/Auth';
import RxSocket from '@Services/RxSocket';
import { RxSocketUrls, DEFAULT_HEARTBEAT_INTERVAL, DEFAULT_HEARTBEAT_FAIL_INTERVAL } from '@Constants/CommonConstants';

// eslint-disable-next-line import/no-mutable-exports
export let interval = null;
// eslint-disable-next-line import/no-mutable-exports
export let _isSessionTimeoutOneTimeChecked;

export const checkSessionTimeout = () => {
  const { details } = Auth.getUser();

  if (!Auth.getAccessToken()) {
    return false; // do not send heartbeat when client has no access token
  }
  if (!details) {
    return true; // send if there is access token, but no data about timeout
  }
  // calculate timeout
  const sessionTimeout = details.sessionTimeout * 1000;
  return new Date().valueOf() - Auth.getLastActionTime() < sessionTimeout;
};

export const isSessionTimeoutOneTimeCheck = () => {
  if (_isSessionTimeoutOneTimeChecked) {
    return;
  }
  _isSessionTimeoutOneTimeChecked = true;

  // convert seconds to ms
  const heartbeatFailInterval = get(Auth.getUser(), 'details.heartbeatFailInterval', DEFAULT_HEARTBEAT_FAIL_INTERVAL) * 1000;
  const lastUse = parseInt(Auth.getAccessToken('lastUse'), 10);
  const heatrbeatSince = Date.now() - lastUse;
  // eslint-disable-next-line consistent-return
  return heatrbeatSince > heartbeatFailInterval;
};

export const start = () => {
  // convert seconds to ms
  const heartbeatInterval = get(Auth.getUser(), 'details.heartbeatInterval', DEFAULT_HEARTBEAT_INTERVAL) * 1000;
  // eslint-disable-next-line no-use-before-define
  interval = setInterval(sendHeartbeat, heartbeatInterval);
};

export const stop = () => {
  if (interval) {
    clearInterval(interval);
    interval = null;
  }
};

export const processSessionExpiry = () => {
  stop();
  RxSocket.disconnect();
  Auth.logoutOnExpiredSession();
};

export const sendHeartbeat = () => {
  const forbidBuffering = true;
  Auth.setAccessToken(Auth.getAccessToken());

  // if user was idle for longer than specified timeout then terminate the session
  // else send the new heartbeat
  if (checkSessionTimeout()) {
    RxSocket.send(RxSocketUrls.ChannelsUrls.Heartbeat, {}, null, forbidBuffering);
  } else {
    processSessionExpiry();
  }
};
